module.exports = __webpack_public_path__ + "static/media/Tile3.320ee6d8.png";